import { render, staticRenderFns } from "./CallLog.vue?vue&type=template&id=3a669522&"
import script from "./CallLog.vue?vue&type=script&lang=js&"
export * from "./CallLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports